/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Window_RequiredInputs */

const vi_irrigation_schedule_window_required = /** @type {(inputs: Irrigation_Schedule_Window_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập giờ`)
};

/**

* @param {Irrigation_Schedule_Window_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_window_required = /** @type {((inputs?: Irrigation_Schedule_Window_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Window_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_window_required(inputs)
});